var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCameraOff = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0145 21.1042C18.7624 21.365 18.3277 21.365 18.0669 21.1042L15.6128 18.6527C15.6129 18.6526 15.6128 18.6527 15.6128 18.6527L2.75107 5.80408C2.75104 5.80411 2.7511 5.80404 2.75107 5.80408L0.888305 3.94301C0.63619 3.6909 0.63619 3.24753 0.888305 2.99541C1.14911 2.7346 1.58379 2.7346 1.8446 2.99541L19.0145 20.1566C19.2753 20.4174 19.2666 20.8434 19.0145 21.1042Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.2127C17 16.3821 16.9899 16.5445 16.9701 16.6996L5.28414 5.01953H14.3386C16.0587 5.01953 17 6.0122 17 7.73224V16.2127Z",
    fill: "#878793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22512 6.69215C2.1214 7.00064 2.06641 7.34832 2.06641 7.73224V16.2127C2.06641 17.9242 3.0933 18.9168 4.81335 18.9168H14.2531C14.3223 18.9168 14.3904 18.9152 14.4574 18.912L2.22512 6.69215Z",
    fill: "#878793"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.4926L21.0212 17.1882C21.3121 17.445 21.6544 17.6075 21.9625 17.6075C22.63 17.6075 23.0664 17.1198 23.0664 16.4181V7.51831C23.0664 6.8166 22.63 6.32882 21.9625 6.32882C21.6544 6.32882 21.3121 6.49141 21.0212 6.74814L18 9.43518V14.4926Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCameraOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-camera-off.909b2b95c1420834127425b3e2a2d81a.svg";